<template>
  <div class="flex w-full">
    <span v-if="textOnly">
      {{ convertedValue.toFixed(2) }}
    </span>
    <MInputGroup v-else compact class="input-group-container">
      <div class="flex-1">
        <MInputNumber
          :value="convertedValue"
          :min="min"
          :max="max"
          :precision="2"
          v-bind="$attrs"
          @update="handleChange"
        />
      </div>
      <div
        v-if="!hideUnitSelection"
        class="px-2 bg-neutral-lightest flex items-center justify-center text-neutral border-solid border-neutral-lighter border-l-0 border-t border-b border-r rounded rounded-tl-none rounded-bl-none"
        style="display: inline-flex"
      >
        {{ $tc(unit) }}
      </div>
    </MInputGroup>
  </div>
</template>

<script>
export default {
  name: 'HertzPicker',
  model: { event: 'change' },
  props: {
    value: { type: Number, default: 0 },
    hideUnitSelection: { type: Boolean, default: false },
    unit: {
      type: String,
      default() {
        return 'ghz'
      },
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: undefined,
    },
    textOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    valueInHertz() {
      if (this.unit === 'ghz') {
        return 1000000000 // hz
      }
      if (this.unit === 'mhz') {
        return 1000000 // hz
      }
      return 1
    },
    convertedValue() {
      const v = parseFloat(this.value)
      if (isNaN(v)) {
        return
      }
      return v / this.valueInHertz
    },
  },
  methods: {
    handleChange(value) {
      const v = parseFloat(value)
      if (isNaN(v)) {
        return
      }
      this.$emit('change', v * this.valueInHertz)
    },
  },
}
</script>

<style lang="less" scoped>
.input-group-container {
  top: 3px !important;
  display: flex !important;
  .@{ant-prefix}-input-number {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
</style>

<style lang="less">
.input-group-container {
  .duration-type {
    .@{ant-prefix}-select-selection {
      @apply bg-neutral-lightest text-neutral;
    }
  }
}
</style>
